import { format as i, differenceInDays as u, parse as p, parseISO as D, isWithinInterval as w } from "date-fns";
import { utcToZonedTime as I } from "date-fns-tz";
const m = () => Array.from(Array(12).keys()), l = ({
  locale: t,
  month: e,
  mode: n = "short"
}) => {
  const r = new Intl.DateTimeFormat(t, {
    month: n
  }), a = (/* @__PURE__ */ new Date()).getFullYear();
  return r.format(new Date(a, e));
}, T = ({
  locale: t,
  day: e,
  mode: n = "short",
  month: r = 1,
  year: a = 2021
}) => new Intl.DateTimeFormat(t, {
  weekday: n
}).format(new Date(a, r, e)), S = ({
  locale: t,
  mode: e
}) => Array.from(Array(7).keys()).map(
  (n) => T({
    locale: t,
    day: n,
    mode: e
  })
), x = ({
  locale: t,
  weekStartAt: e = 1,
  mode: n = "short"
}) => {
  const r = S({ locale: t, mode: n });
  return [
    ...r.slice(e, r.length),
    ...r.slice(0, e)
  ];
}, v = (t = 1) => {
  const e = Array.from(Array(7).keys());
  return [
    ...e.slice(t, e.length),
    ...e.slice(0, t)
  ];
}, N = (t) => {
  const e = new Date(t), n = new Date(t), r = t.getDate() - t.getDay() + 1, a = r + 6;
  return e.setDate(r), n.setDate(a), {
    firstDay: e,
    lastDay: n
  };
}, A = ({ locale: t, mode: e }) => m().map((n) => l({ locale: t, month: n, mode: e })), U = (t, e = "long") => m().map((n) => ({ value: n, label: l({ locale: t, month: n, mode: e }) })), _ = (t) => {
  const e = t.getDay();
  return e === 0 || e === 6;
}, C = (t) => {
  const e = /* @__PURE__ */ new Date();
  return t.getDate() === e.getDate() && t.getMonth() === e.getMonth() && t.getFullYear() === e.getFullYear();
}, c = (t, e) => {
  const n = new Date(t), r = new Date(e);
  return n.setHours(0, 0, 0, 0), r.setHours(0, 0, 0, 0), n.getTime() - r.getTime();
}, b = ({
  month: t,
  year: e
}) => {
  const n = (t + 1) % 12, r = new Date(e, n, 0).getDate();
  return {
    days: Array(r).fill(0).map((a, o) => o + 1),
    startsOn: new Date(e, t, 1).getDay()
  };
}, $ = (t) => {
  const e = (t + 1) % 12, n = (/* @__PURE__ */ new Date()).getFullYear();
  return new Date(n, e, 0).getDate();
}, E = (t, e) => t && e ? c(t, e) === 0 : !1, j = (t, e) => t && e ? c(t, e) > 0 : !1, B = (t, e) => t && e ? c(t, e) < 0 : !1, G = ({ year: t, offset: e }) => {
  const n = Array.from(Array(e).keys()), r = n.map((o) => t - (o + 1)).reverse(), a = n.map((o) => t + (o + 1));
  return [...r, t, ...a];
}, V = ({ day: t, month: e, year: n }) => new Date(n, e, t), Z = (t) => t ? t.toISOString().split("T")[0] : "", q = (t, e) => Intl.DateTimeFormat(t, { dateStyle: "short" }).format(new Date(e)), J = (t) => {
  const e = t.getTimezoneOffset();
  return new Date(t.getTime() - e * 60 * 1e3).toISOString().split("T")[0];
}, K = ({
  locale: t,
  date: e
}) => e.toLocaleDateString(t, {
  year: "numeric",
  month: "short",
  day: "numeric"
}), P = ({
  locale: t,
  date: e
}) => e.toLocaleDateString(t, {
  month: "short",
  day: "numeric"
}), Q = ({
  locale: t,
  date: e
}) => e.toLocaleDateString(t, {
  year: "numeric",
  month: "long",
  day: "numeric"
}), z = (t) => t.charAt(0).toUpperCase() + t.slice(1), g = (t, e, n) => {
  const r = e.toLocaleDateString(t, n), a = { month: n.month }, o = e.toLocaleDateString(t, a), s = z(o);
  return r.replace(o, s);
}, X = ({
  locale: t,
  date: e
}) => g(t, e, {
  month: "short",
  day: "numeric"
}), R = ({
  locale: t,
  date: e
}) => g(t, e, {
  year: "numeric",
  month: "long",
  day: "numeric"
});
var L = /* @__PURE__ */ ((t) => (t.ISO = "yyyy-MM-dd", t.EU = "dd/MM/yyyy", t.US = "MM/dd/yyyy", t.EU_2_DIGITS = "dd/MM/yy", t.EU_DASHES = "dd-MM-yyyy", t.EU_2_DIGITS_DATE_TIME = "dd/MM/yy HH:mm", t))(L || {});
const d = (t, e, n = {}) => {
  const { separator: r = " " } = n;
  return [
    "yyyy-MM-dd",
    "dd-MM-yyyy",
    "MM/dd/yyyy",
    "dd/MM/yyyy",
    "dd/MM/yy"
    /* EU_2_DIGITS */
  ].includes(t) ? i(e, t) : t === "dd/MM/yy HH:mm" ? i(e, t.replace(" ", r)) : e.toISOString();
}, tt = (t, e = "en") => new Intl.DateTimeFormat(e, {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric"
}).format(t), f = (t, e) => Math.abs(u(e, t)), y = ({ date: t, days: e }) => {
  const n = new Date(t);
  return n.setDate(n.getDate() + e), n;
}, et = ({ date: t, days: e }) => {
  const n = new Date(t);
  return n.setDate(n.getDate() - e), n;
}, O = (t) => p(t, "yyyy-MM-dd", h(/* @__PURE__ */ new Date())), F = (t) => {
  const e = new Date(t.getFullYear(), 0, 1), n = new Date(t.getFullYear(), 6, 1), r = -Math.max(
    e.getTimezoneOffset(),
    n.getTimezoneOffset()
  );
  return Y(r);
}, Y = (t) => {
  const e = Math.floor(Math.abs(t) / 60), n = Math.abs(t % 60), r = `${e}`.padStart(2, "0"), a = `${n}`.padStart(2, "0");
  return `${t < 0 ? "-" : "+"}${r}:${a}`;
}, nt = (t) => {
  const e = O(t), n = F(e);
  return D(
    `${d("yyyy-MM-dd", e)}T00:00:00${n}`
  );
}, rt = (t) => D(t), at = ({
  startDate: t,
  endDate: e,
  includeEndDate: n
}) => {
  let r = f(t, e);
  return n && (r += 1), Array.from({ length: r }).map((a, o) => y({
    date: t,
    days: o
  }));
}, ot = ({
  startDate: t,
  endDate: e,
  includeEndDate: n,
  format: r = "yyyy-MM-dd"
  /* ISO */
}) => {
  let a = f(t, e);
  return n && (a += 1), Array.from({ length: a }).map((o, s) => {
    const M = y({
      date: t,
      days: s
    });
    return d(r, M);
  });
}, st = (t) => y({
  date: t,
  days: 1
}).getMonth() !== t.getMonth(), ct = (t) => {
  const e = (/* @__PURE__ */ new Date()).getFullYear(), n = e - t;
  return Array.from({ length: e - n }, (r, a) => {
    const o = n + a + 1;
    return { value: o, label: o.toString() };
  });
}, yt = (t) => t instanceof Date && !isNaN(t), it = ({
  date: t,
  start: e,
  end: n
}) => e.getTime() > n.getTime() ? !1 : w(t, { start: e, end: n }), ut = (t, e) => u(t, e), W = () => {
  const {
    Amenitiz: { hotelTimezone: t }
  } = window;
  return t();
}, h = (t) => {
  const e = W();
  return I(t, e);
}, Dt = () => h(/* @__PURE__ */ new Date()), mt = (t, e) => {
  const n = new Date(t, e, 1);
  return new Date(n.getFullYear(), n.getMonth(), 1);
}, lt = (t, e) => {
  const n = new Date(t, e, 1);
  return new Date(n.getFullYear(), n.getMonth() + 1, 0);
};
export {
  L as DATE_FORMATS,
  y as addDays,
  E as areDatesEqual,
  c as compareDates,
  d as formatDate,
  P as formatDateCompact,
  X as formatDateCompactWithCapitalizedMonth,
  J as formatDateISO8601,
  q as formatDateLocale,
  Q as formatDateLong,
  R as formatDateLongWithCapitalizedMonth,
  K as formatDateShort,
  Y as formatTimeZoneOffset,
  tt as fullDateFormat,
  V as getDate,
  h as getDateInHotelTimezone,
  Z as getDateOnlyString,
  at as getDateRange,
  ot as getDateRangeFormated,
  f as getDaysDifference,
  $ as getDaysInMonth,
  b as getDaysOfTheMonth,
  ut as getDifferenceInDays,
  mt as getFirstDateOfTheMonth,
  W as getHotelTimezone,
  lt as getLastDateOfTheMonth,
  l as getMonthName,
  A as getMonthNames,
  m as getMonths,
  U as getMonthsValueLabel,
  F as getTimeZoneOffset,
  Dt as getTodayDateInHotelTimezone,
  N as getWeekFirstAndLastDays,
  T as getWeekdayName,
  S as getWeekdayNames,
  x as getWeekdayNamesLocale,
  v as getWeekdaysLocale,
  G as getYears,
  ct as getYearsRange,
  j as isDateAfter,
  B as isDateBefore,
  yt as isDateValid,
  it as isDateWithinInterval,
  st as isLastDayOfTheMonth,
  C as isToday,
  _ as isWeekendDay,
  O as parseDate,
  rt as parseDateISO8601,
  nt as parseDateWithinTimezone,
  et as substractDays
};
